import React from 'react';
import { useParams } from 'react-router-dom';
import PresencasReuniaoPanel from './PresencasReuniaoPanel';

/** Tela dedicada (mesmo conteúdo de presenças na página da reunião). */
const GerenciarPresencas = () => {
  const { id } = useParams();
  return <PresencasReuniaoPanel reuniaoId={id} embedded={false} />;
};

export default GerenciarPresencas;
